export const TEAM_ALPHA_TAG = 'team-alpha';
export const TEAM_BETA_TAG = 'team-beta';
export const EDUCATION_VERIFIED_TAG = 'educationVerified';
